export function replacePhaseActivities(phases, phaseId, activities) {
  return phases
    ? phases.map(phase =>
        phase.id === phaseId ? { ...phase, activities } : phase
      )
    : phases
}
